import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import apiService from '../services/apiService';
import './PaymentStatusPage.css';

const PaymentStatusPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { paymentIntentId } = useParams();
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);
  const [sessionDetails, setSessionDetails] = useState(null);

  const paymentId = location.state?.paymentIntentId || paymentIntentId;

  useEffect(() => {
    const checkStatus = async () => {
      if (!paymentId) {
        setError('No payment ID provided');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await apiService.checkPaymentStatus(paymentId);
        
        if (response.status === 'success') {
          setStatus(response.data.payment_status);
          setSessionDetails(response.data.session);
        } else {
          setError(response.message || 'Failed to retrieve payment status');
        }
      } catch (error) {
        console.error('Error checking payment status:', error);
        setError(error.message || 'An error occurred while checking payment status');
      } finally {
        setLoading(false);
      }
    };

    checkStatus();
  }, [paymentId]);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="payment-status-container">
      <header className="payment-status-header">
        <h1>RGVSMARTPAY</h1>
      </header>

      <main className="payment-status-content">
        <div className="payment-status-card">
          <h2>Payment Status</h2>

          {loading ? (
            <div className="loading-status">
              <p>Checking payment status...</p>
            </div>
          ) : error ? (
            <div className="error-status">
              <h3>Error</h3>
              <p>{error}</p>
              <button className="status-button" onClick={handleGoHome}>
                Return Home
              </button>
            </div>
          ) : (
            <div className="status-details">
              <div className={`status-badge ${status?.toLowerCase() || 'unknown'}`}>
                {status || 'Unknown'}
              </div>

              {status === 'succeeded' && sessionDetails && (
                <div className="session-details">
                  <h3>Parking Session Details</h3>
                  <div className="detail-row">
                    <span>License Plate:</span>
                    <span>{sessionDetails.license_plate}</span>
                  </div>
                  <div className="detail-row">
                    <span>Zone:</span>
                    <span>{sessionDetails.zone_code}</span>
                  </div>
                  <div className="detail-row">
                    <span>Start Time:</span>
                    <span>{formatDate(sessionDetails.start_time)}</span>
                  </div>
                  <div className="detail-row">
                    <span>End Time:</span>
                    <span>{formatDate(sessionDetails.end_time)}</span>
                  </div>
                  <div className="detail-row">
                    <span>Amount Paid:</span>
                    <span>${parseFloat(sessionDetails.amount_paid).toFixed(2)}</span>
                  </div>
                </div>
              )}

              {status === 'pending' && (
                <div className="pending-message">
                  <p>Your payment is still being processed. This page will automatically refresh in 10 seconds.</p>
                </div>
              )}

              {status === 'failed' && (
                <div className="failed-message">
                  <p>Unfortunately, your payment failed. Please try again.</p>
                  <button className="status-button" onClick={() => navigate(-1)}>
                    Try Again
                  </button>
                </div>
              )}

              <div className="status-actions">
                <button className="status-button" onClick={handleGoHome}>
                  Return Home
                </button>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default PaymentStatusPage; 